import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { TwoColumn } from 'components/layout/two-column/TwoColumn'
import { Button } from 'components/buttons'
import { faPlus } from '@fortawesome/pro-regular-svg-icons'
import { ApproversTable } from '@features/admin/features/approval-domain-approvers'

interface Approver {
  id: number
  user: BasicUser
  allFacilities: boolean
  allWorkdayDepartments: boolean
  facilityIds: number[]
  workdayDepartmentIds: string[]
}

interface Props {
  approvalGroup: AdminApprovalGroup
  onAdd: () => void
  onEdit: (approver: Approver) => void
  onDelete: (approver: Approver) => void
}

export const ApproversSection: FC<Props> = ({
  approvalGroup,
  onAdd,
  onEdit,
  onDelete,
}) => {
  const { t } = useTranslation()

  return (
    <TwoColumn
      label={t('common.approvers')}
      description={t(
        'features.approvalGroupsAdmin.approvalGroupDetails.approversDescription',
      )}
      leftSlot={
        <Button
          title={t('features.approvalDomainApprovers.addApprovers')}
          icon={faPlus}
          className="text-sm"
          onClick={onAdd}
        >
          {t('features.approvalDomainApprovers.addApprovers')}
        </Button>
      }
    >
      <ApproversTable
        approvalDomainId={approvalGroup.globalId}
        onAdd={onAdd}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </TwoColumn>
  )
}
